import React, {useEffect, useRef, useState} from 'react';
import {useClientInfoQuery} from '../../../../redux/userClientsApi';
import {toast} from 'react-toastify';
import ModalWrapper from '../../../../Components/ModalWrapper/ModalWrapper';
import ClientInfoTitle from './components/ClientInfoTitle';
import ClientInfoColumn from './components/ClientInfoColumn';
import ClientInfoColumnSecond from './components/ClientInfoColumnSecond';
import HistoryButtons from './components/HistoryButtons';
import TableContainer from './components/TableContainer';
import styles from './ClientInfoPopup.module.css';

type Props = {
	clientInfo: number;
	setClientInfo: (c: number) => void;
	selectedMonth?: string;
};
const ClientInfoPopup: React.FC<Props> = ({
	clientInfo,
	setClientInfo,
	selectedMonth,
}) => {
	const {data, isLoading, isError, error} = useClientInfoQuery(clientInfo);
	const [showOrdersTable, setShowOrdersTable] = useState(false);
	const [showActivitiesTable, setShowActivitiesTable] = useState(false);

	const handleChangeParent = (id: number) => {
		setClientInfo(id);
	};

	const handleToggleOrders = () => {
		setShowOrdersTable(!showOrdersTable);
		setShowActivitiesTable(false);
	};

	const handleToggleActivities = () => {
		setShowActivitiesTable(!showActivitiesTable);
		setShowOrdersTable(false);
	};

	const lastErrorRef = useRef<string>();

	useEffect(() => {
		if (isError && error && 'data' in error) {
			const msg = error.data.message?.textmsg;
			if (msg && lastErrorRef.current !== msg) {
				lastErrorRef.current = msg;
				toast.error(msg);
			}
		}
	}, [isError, error]);

	useEffect(() => {
		setShowOrdersTable(false);
		setShowActivitiesTable(false);
	}, [clientInfo]);

	if (data && !isLoading) {
		return (
			<ModalWrapper handleClosePopup={() => setClientInfo(0)}>
				<div className={styles.clientInfoItem}>
					<ClientInfoTitle
						name={data.name}
						surname={data.surname}
						middlename={data.middlename}
					/>

					<div className={styles.clientInfoRow}>
						<ClientInfoColumn data={data} onParentClick={handleChangeParent} />
						<ClientInfoColumnSecond data={data} />
					</div>

					<HistoryButtons
						showOrdersTable={showOrdersTable}
						showActivitiesTable={showActivitiesTable}
						onToggleOrders={handleToggleOrders}
						onToggleActivities={handleToggleActivities}
					/>

					<TableContainer
						showTable={showOrdersTable}
						clientId={clientInfo}
						selectedMonth={selectedMonth}
						tableType="orders"
					/>

					<TableContainer
						showTable={showActivitiesTable}
						clientId={clientInfo}
						selectedMonth={selectedMonth}
						tableType="activities"
					/>
				</div>
			</ModalWrapper>
		);
	} else return null;
};

export default ClientInfoPopup;
